import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component } from "@angular/core";
import { Observable } from "rxjs";
import { TheraHeaderActionButtonComponent } from "src/app/common/components/core/header-action-button/header-action-button.component";
import { Announcement, AnnouncementPanelService } from "../announcement-panel.service";
import { ANNOUNCEMENT_BANNER_TEXT } from "../announcement-banner-constants";

@Component({
  selector: "app-announcement-bell",
  standalone: true,
  imports: [CommonModule, TheraHeaderActionButtonComponent],
  templateUrl: "./announcement-bell.component.html",
  styleUrls: ["./announcement-bell.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnnouncementBellComponent {
  text = ANNOUNCEMENT_BANNER_TEXT;
  active$: Observable<Announcement[]> = this.panelService.active$;

  constructor(private panelService: AnnouncementPanelService) {}

  openList(): void {
    this.panelService.openList();
  }
}
